import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "cross",
  "use": "cross-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"cross\">\r\n<title>cross</title>\r\n<path d=\"M0 3.5l3.4-3.5 28.6 28.5-3.4 3.5c0 0-28.6-28.5-28.6-28.5z\" />\r\n<path d=\"M0 28.5l28.7-28.5 3.3 3.5-28.7 28.5c0 0-3.3-3.5-3.3-3.5z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol